import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck, Award, Stethoscope } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <img
                src="https://customer-assets.emergentagent.com/job_hormone-wellness-1/artifacts/emqp5y2s_symbol%20%281%29.svg"
                alt="Glow Health Logo"
                className="logo-symbol"
              />
              <span className="logo-text">Glow Health</span>
            </div>
            <p className="footer-tagline">Where women finally get answers.</p>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/pricing">Pricing</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Services</h4>
            <ul className="footer-links">
              <li><Link to="/perimenopause">Perimenopause</Link></li>
              <li><Link to="/menopause">Menopause</Link></li>
              <li><Link to="/pmos">PMOS (formerly PCOS)</Link></li>
              <li><Link to="/pmdd">PMDD</Link></li>
              <li><Link to="/postpartum">Postpartum</Link></li>
              <li><Link to="/thyroid">Thyroid</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Legal</h4>
            <ul className="footer-links">
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/terms-of-service">Terms of Service</Link></li>
              <li><Link to="/medical-disclaimer">Medical Disclaimer</Link></li>
              <li><Link to="/health-privacy-notice">Health Information Privacy</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Contact</h4>
            <p className="footer-text">Virtual consultations nationwide</p>
            <p className="footer-text">
              <a href="tel:385-396-5565" className="footer-link">385-396-5565</a>
            </p>
            <p className="footer-text">support@myglowhealth.co</p>
            <p className="footer-text">Monday - Friday: 9am - 6pm EST</p>
          </div>
        </div>

        <div className="footer-credentials" data-testid="footer-credentials">
          <div className="footer-cred-item">
            <ShieldCheck size={15} strokeWidth={1.5} />
            <span>HIPAA Compliant</span>
          </div>
          <div className="footer-cred-item">
            <Award size={15} strokeWidth={1.5} />
            <span>Board-Certified Clinicians</span>
          </div>
          <div className="footer-cred-item">
            <Stethoscope size={15} strokeWidth={1.5} />
            <span>Licensed Telehealth, Nationwide</span>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-disclaimer">
            Glow Health LLC provides telehealth services for hormone optimization and does not replace emergency medical care. 
            All information is HIPAA-compliant and confidential. If you are experiencing a medical emergency, please call 911.
          </p>
          <div className="footer-legal">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <span>•</span>
            <Link to="/terms-of-service">Terms of Service</Link>
            <span>•</span>
            <Link to="/medical-disclaimer">Medical Disclaimer</Link>
            <span>•</span>
            <Link to="/health-privacy-notice">Health Privacy Notice</Link>
          </div>
          <p className="footer-copyright">© 2025 Glow Health LLC. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;